export default __webpack_public_path__ + "static/media/Screenshot_3.4e035116.png";